import { render, staticRenderFns } from "./preview-receipt.vue?vue&type=template&id=7c810ea4&scoped=true&"
import script from "./preview-receipt.vue?vue&type=script&lang=js&"
export * from "./preview-receipt.vue?vue&type=script&lang=js&"
import style0 from "./preview-receipt.vue?vue&type=style&index=0&id=7c810ea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c810ea4",
  null
  
)

export default component.exports